import * as THREE from 'three'

import Experience from './Experience.js'

/* 射线拾取：悬停提示 + 点击动作（区分点击与拖拽） */
export default class ZhuyuInteractions
{
    constructor(_props, _egg)
    {
        this.experience = new Experience()
        this.camera = this.experience.camera
        this.sizes = this.experience.sizes
        this.targetElement = this.experience.targetElement

        this.props = _props
        this.egg = _egg

        this.raycaster = new THREE.Raycaster()
        this.pointer = new THREE.Vector2()
        this.tooltip = document.getElementById('zhuyuTooltip')
        this.downAt = null

        this.targetElement.addEventListener('pointermove', (e) => this.onMove(e))
        this.targetElement.addEventListener('pointerdown', (e) => { this.downAt = { x: e.clientX, y: e.clientY } })
        this.targetElement.addEventListener('pointerup', (e) => this.onUp(e))
    }

    pick(x, y)
    {
        this.pointer.set(
            (x / this.sizes.width) * 2 - 1,
            -(y / this.sizes.height) * 2 + 1
        )
        this.raycaster.setFromCamera(this.pointer, this.camera.instance)
        const hits = this.raycaster.intersectObjects(this.props.interactives, true)
        return hits.length ? hits[0].object.userData.zhuyu : null
    }

    onMove(e)
    {
        const tip = this.pick(e.clientX, e.clientY)
        if(tip)
        {
            const note = tip.action.type === 'link' ? '<small>点击去抖音看这条</small>'
                : tip.action.type === 'egg' ? '<small>点一下试试？</small>' : ''
            this.tooltip.innerHTML = tip.name + note
            this.tooltip.style.left = e.clientX + 'px'
            this.tooltip.style.top = e.clientY + 'px'
            this.tooltip.classList.add('on')
            document.body.style.cursor = 'pointer'
        }
        else
        {
            this.tooltip.classList.remove('on')
            document.body.style.cursor = ''
        }
    }

    onUp(e)
    {
        if(!this.downAt)
            return
        const moved = Math.hypot(e.clientX - this.downAt.x, e.clientY - this.downAt.y)
        this.downAt = null
        if(moved > 8)
            return

        const tip = this.pick(e.clientX, e.clientY)
        if(!tip)
            return
        if(tip.action.type === 'link')
            window.open(tip.action.url, '_blank', 'noopener')
        else if(tip.action.type === 'egg')
            this.egg.open()
    }
}
